import React from "react";
import { _makeId } from "../utils/helper";

const Checkbox = ({
  label,
  value,
  onChange,
  onFocus,
  onBlur,
  checked,
  ...props
}) => {
  // const id = _makeId(5);

  const id = `${label.toLowerCase().replace(/\s+/g, '-')}-${value}`;


  // Function to handle key presses on the label
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // Get the checkbox element
      const checkbox = document.getElementById(id);
      if (checkbox) {
        // Toggle the checkbox's checked state
        checkbox.checked = !checkbox.checked;
        // Trigger the onChange event
        onChange(checkbox.checked, value);
      }
    }
  };

  return (
    <div className="tema-checkbox">
      <input
        type="checkbox"
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.checked, value)}
        onFocus={onFocus}
        onBlur={onBlur}
        checked={checked}
      />
      <label
        htmlFor={id}
        className="whitespace-nowrap checkbox-text"
        tabIndex={0} // only if needed for keyboard handlers
        onKeyDown={handleKeyDown}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
